import React, { useContext, useEffect, useState } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui'
import { Switch } from '../../../../common/formik';

import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    Divider
} from '@material-ui/core';

import {     
    Select,
    InputFiles,
    FileList,
    FieldError
} from '../../../../common'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { UserContext } from '../../../../contexts/UserContext';

import { SapTableNames, ApplicationRoles, RequestStatus } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const LogisticsForm = (props) => {
    const classes = useStyles();

    const {
        state,
        getTableOptionsWithCode
    } = useContext(CustomerRequestContext)

    const { 
        values,
        setFieldValue,
        isSavingRequest,
    } = useContext(TabsContext);

    const {
        userInfo,
        getUserInfo,
        isUserInRole,
        isUserInRoles
    } = useContext(UserContext);
    
    const fileUploadedHandler = (storedFile) => {
        const docs = [].concat(values.shippingDocs || []);
        docs.push({ ...storedFile });                
        // We need to set the value manually
        // otherwise setFieldValue will not work property
        values.shippingDocs = docs;
        setFieldValue("shippingDocs", docs);
    }

    const fileRemovedHandler = (storedFile) => {
        const docs = values.shippingDocs.filter(x => x.storedFileId !== storedFile.storedFileId);
        // We need to set the value manually
        // otherwise setFieldValue will not work property
        values.shippingDocs = docs;
        setFieldValue("shippingDocs", docs);
    }    

    return (
        <Card className={classes.card}>
            <CardHeader title="Logistics information" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="incotermsId"
                            label="Incoterms *"
                            disabled={props.disabled || state.request.status === RequestStatus.AccountReceivableApproval}
                            options={getTableOptionsWithCode(SapTableNames.Incoterms, values.dbType)}
                        />
                        <FieldError name="incotermsId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="incotermsLocation"
                            label="Incoterms location *"
                            disabled={props.disabled || state.request.status === RequestStatus.AccountReceivableApproval}
                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                            component={TextField}
                        />
                        <FieldError name="incotermsLocation" errors={state.errors} />
                    </Grid>              
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="shipAddress"
                            helperText="Intermediate ship to / notify party address and contact details transportation"
                            label="Ship address or contact details"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="shipAddress" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="purchasingContact"
                            label="Purchasing contact details"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="purchasingContact" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="warehouseContact"
                            label="Warehouse contact details"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="warehouseContact" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="administrationContact"
                            label="Administration contact details"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="administrationContact" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="additionalShippingDoc"
                            label="Additional shipping documentation"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="additionalShippingDoc" errors={state.errors} />
                    </Grid>
                    <Divider style={{width:"100%"}}/>
                    <Grid item xl={12} md={12} xs={12}>
                        <FileList 
                            title="Attachments"
                            files={values ? values.shippingDocs : []}
                            disabled={props.disabled}
                            onFileRemoved={fileRemovedHandler}
                        />
                        <FieldError name="shippingDocs" errors={state.errors} />
                    </Grid>                    
                    {!props.disabled && 
                        <Grid item xl={12} md={12} xs={12}>
                            <InputFiles 
                                title="Upload shipping docs"
                                onFileUploaded={fileUploadedHandler}/>
                        </Grid>
                    }
                    <Divider style={{width:"100%"}}/>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            name="preferredTransportMode"
                            className={classes.field}
                            variant="outlined"
                            type="text"                            
                            label="Preferred mode of transport"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="preferredTransportMode" errors={state.errors} />
                    </Grid>
                    {/*removed this field because the customers doesn't want it anymore (21/10/2020)
                    <Grid item xl={12} md={12} xs={12} >
                        <Select
                            name="deliveryDateMandatoryId"
                            label="Requested delivery date mandatory"
                            disabled={props.disabled}
                            options={getTableOptions(SapTableNames.RequestedDeliveryDateMandatory, null, true)}
                        />
                        <FieldError name="deliveryDateMandatoryId" />
                    </Grid> */}
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            name="additionalShippingInfo"
                            className={classes.field}
                            variant="outlined"
                            type="text"                            
                            label="Additional information"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="additionalShippingInfo" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            name="cities"                            
                            className={classes.field}
                            variant="outlined"
                            type="text"                            
                            label="Cites"
                            helperText="Only if importer address is different from sold to"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="cities" errors={state.errors} />
                    </Grid>
                    {
                        !values.isDraftJWA &&
                        <Grid item xl={12} md={12} xs={12}>
                            <Field
                                name="acceptBackOrders"
                                label="Does the customer accept back orders?"                            
                                disabled={props.disabled || state.request.status === RequestStatus.AccountReceivableApproval}
                                component={Switch} 
                            />
                            <FieldError name="acceptBackOrders" errors={state.errors} />
                        </Grid>
                    }
                    {/*removed this field because the customers doesn't want it anymore (21/10/2020)
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            name="fire"
                            label="FI.RE."                            
                            disabled={isSavingRequest || props.disabled}
                            component={Switch} 
                        />
                        <FieldError name="fire" errors={state.errors} />
                    </Grid> */}
                </Grid>
            </CardContent>
        </Card>
    );
}